/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-shadow */
import React, { useState, useRef, useEffect } from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import * as MUI from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm, SubmitHandler, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useAuth } from "../../hooks/auth";

import {
  FormInputText,
  FormInputPassword,
  FormInputSelect,
} from "../../components/Form/Input/FormInput";

type IFormLogin = {
  login: string;
  senha: string;
  orgao: string;
};

interface State {
  password: string;
  showPassword: boolean;
}

const schemaLogin = yup.object().shape({
  login: yup.string().required("Preencha o campo de Login"),
  senha: yup.string().required("Preencha o campo de senha"),
  orgao: yup.string().required("Escolha um orgão"),
});

const isHomolog = process.env.REACT_APP_ENVIRONMENT === "hml";

export const Login: React.FC = () => {
  const theme = MUI.useTheme();
  const { login: loginAuth, confirmOTP: confirmOTPAuth } = useAuth();
  const [tempSecret, setTempSecret] = useState<string | null>(null);
  const otpInputRef = useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const [liberado, setLiberado] = useState(isHomolog);
  const [values, setValues] = useState<State>({
    password: "",
    showPassword: false,
  });
  const [step, setStep] = useState<"login" | "otp" | "qr">("login");
  const [otp, setOtp] = useState("");
  const [loginData, setLoginData] = useState<IFormLogin | null>(null);
  const [qrCode, setQrCode] = useState<string | null>(null);
  const [error, setError] = useState("");
  const methods = useForm<IFormLogin>({
    resolver: yupResolver(schemaLogin),
  });

  // Focus no input OTP quando entrar na tela
  useEffect(() => {
    if (step === "otp" && otpInputRef.current) {
      otpInputRef.current.focus();
    }
  }, [step]);

  const onSubmit: SubmitHandler<IFormLogin> = async (data: IFormLogin) => {
    setLoading(true);
    setError("");

    try {
      await schemaLogin.validate(data, { abortEarly: false });

      const result = await loginAuth({
        USUARIO: data.login,
        SENHA: data.senha,
        BASE: data.orgao,
        SISTEMA: "policiaagil-web",
      });
      // Adicionar cooldown se houver mensagem de erro
      if (result.success === false) {
        setCooldown(true);
        setTimeout(() => setCooldown(false), 4000);
      }
      // Quando recebe o QR code do backend
      if (result.setupOTP && result.qrCode) {
        setQrCode(result.qrCode);

        // Tentar com tempSecret direto
        if (result.tempSecret) {
          setTempSecret(result.tempSecret);
          sessionStorage.setItem("@webSDS:tempSecret", result.tempSecret);
          sessionStorage.setItem("@webSDS:loginData", JSON.stringify(data));
        }
        // Tentar com tempSecretBase64
        else if (result.tempSecretBase64) {
          try {
            // Decodificar de Base64 para UTF-8
            const decodedSecret = atob(result.tempSecretBase64);

            setTempSecret(decodedSecret);
            sessionStorage.setItem("@webSDS:tempSecret", decodedSecret);
            sessionStorage.setItem(
              "@webSDS:tempSecretBase64",
              result.tempSecretBase64
            );
            sessionStorage.setItem("@webSDS:loginData", JSON.stringify(data));
          } catch (error) {
            // Nada a fazer aqui
            console.error("Erro ao decodificar tempSecretBase64:", error);
          }
        } else {
          // Nada a fazer aqui
        }

        setStep("qr");
      } else if (result.requireOTP) {
        setLoginData(data);

        if (result.setupOTP && result.qrCode) {
          setQrCode(result.qrCode);

          // ADICIONE UM LOG para verificar se o tempSecret está chegando

          // Salve o tempSecret corretamente
          if (result.tempSecret) {
            setTempSecret(result.tempSecret);
            sessionStorage.setItem("@webSDS:tempSecret", result.tempSecret);
            sessionStorage.setItem("@webSDS:loginData", JSON.stringify(data));
          } else {
            // Nada a fazer aqui
          }

          setStep("qr");
        } else {
          setStep("otp");
        }
        setError(result.message || "");
      } else if (result.success || result.token) {
        window.location.href = "/pagina-inicial";
      } else if (result.message) {
        setError(result.message);
      } else {
        setError("Falha na autenticação");
      }
    } catch (validationError) {
      // cc
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Recuperar loginData do sessionStorage
    let loginDataToUse = loginData;
    if (!loginDataToUse) {
      try {
        const storedLoginData = sessionStorage.getItem("@webSDS:loginData");
        if (storedLoginData) {
          loginDataToUse = JSON.parse(storedLoginData);
        }
      } catch (error) {
        // jjj
      }
    }

    // Recuperar explicitamente o tempSecret do sessionStorage
    const storedTempSecret = sessionStorage.getItem("@webSDS:tempSecret");

    // Usar o tempSecret do estado OU do sessionStorage
    const secretToUse = storedTempSecret || tempSecret;

    setLoading(true);
    setError("");

    try {
      let result;

      if (secretToUse) {
        // Verificar se loginDataToUse não é null antes de usar
        if (!loginDataToUse) {
          setError("Dados de login não encontrados. Faça login novamente.");
          setLoading(false);
          return;
        }

        result = await confirmOTPAuth({
          USUARIO: loginDataToUse.login,
          SENHA: loginDataToUse.senha,
          BASE: loginDataToUse.orgao,
          OTP: otp,
          tempSecret: secretToUse,
        });
      } else {
        // Verificar se loginDataToUse não é null antes de usar
        if (!loginDataToUse) {
          setError("Dados de login não encontrados. Faça login novamente.");
          setLoading(false);
          return;
        }

        result = await loginAuth({
          USUARIO: loginDataToUse.login,
          SENHA: loginDataToUse.senha,
          BASE: loginDataToUse.orgao,
          SISTEMA: "policiaagil-web",
          OTP: otp,
        });
      }

      if (result.success || result.token) {
        // Limpe os dados após uso bem-sucedido
        sessionStorage.removeItem("@webSDS:tempSecret");
        sessionStorage.removeItem("@webSDS:loginData");
        window.location.href = "/pagina-inicial";
      } else {
        setError(result.message || "Código OTP inválido");
      }
    } catch (error: any) {
      setError(error?.message || "Erro ao validar código. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  function onChange(token: string | null) {
    setLiberado(true);
  }

  let content;

  if (step === "login") {
    content = (
      <FormProvider {...methods}>
        <MUI.Stack
          width={["95%", "30rem", "30rem"]}
          height="100%"
          justifyContent="center"
          component="form"
          onSubmit={methods.handleSubmit(onSubmit)}
        >
          <MUI.Typography
            variant="body1"
            fontWeight="bold"
            color={theme.palette.primary.dark}
          >
            ENTRAR NO SISTEMA
          </MUI.Typography>
          <MUI.Divider
            sx={{
              borderWidth: 1.5,
              backgroundColor: `${theme.palette.primary.dark}`,
            }}
          />
          <MUI.Stack py={2} gap={[1, 1, 1, 1, 2]}>
            {error && (
              <MUI.Typography color="error" variant="body2" textAlign="center">
                {error}
              </MUI.Typography>
            )}
            <FormInputText name="login" label="Usuário*" />
            <FormInputPassword
              name="senha"
              label="Senha *"
              type={values.showPassword ? "text" : "password"}
              handleClickShowPassword={handleClickShowPassword}
              handleMouseDownPassword={() => handleMouseDownPassword}
            />
            <FormInputSelect
              name="orgao"
              label="Orgão *"
              items={[
                {
                  key: "1",
                  value: "bombeiros",
                  label: "CBMPE - @bombeiros.pe.gov.br",
                },
                {
                  key: "2",
                  value: "camil",
                  label: "CASA MILITAR - @camil.pe.gov.br",
                },
                {
                  key: "3",
                  value: "ciids",
                  label: "CIIDS - @ciids.pe.gov.br",
                },
                {
                  key: "4",
                  value: "corregedoria.sds",
                  label: "CORREG - @corregedoria.sds.pe.gov.br",
                },
                {
                  key: "5",
                  value: "ic",
                  label: "IC - @ic.pe.gov.br",
                },
                {
                  key: "6",
                  value: "iitb",
                  label: "IITB - @iitb.pe.gov.br",
                },
                {
                  key: "7",
                  value: "iml",
                  label: "IML - @iml.pe.gov.br",
                },
                {
                  key: "8",
                  value: "policiacientifica",
                  label: "POLÍCIA CIENTÍFICA - @policiacientifica.pe.gov.br",
                },
                {
                  key: "9",
                  value: "policiacivil",
                  label: "PCPE - @policiacivil.pe.gov.br",
                },
                {
                  key: "10",
                  value: "pm",
                  label: "PMPE - @pm.pe.gov.br",
                },
                {
                  key: "11",
                  value: "sds",
                  label: "SDS - @sds.pe.gov.br",
                },
                {
                  key: "12",
                  value: "seap",
                  label: "SEAP - @seap.pe.gov.br",
                },
                {
                  key: "13",
                  value: "ext",
                  label: "INSTITUIÇÃO EXTERNA",
                },
              ]}
            />
            {!isHomolog && (
              <ReCAPTCHA
                sitekey={
                  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
                  "6LdEFFUiAAAAAJIlfdD1xLc0EiAQMrGPLDcyHaLc"
                }
                onChange={(token) => onChange(token)}
              />
            )}
            <MUI.Button
              type="submit"
              variant="contained"
              disabled={!liberado || loading || cooldown}
            >
              {loading || cooldown ? (
                <MUI.CircularProgress color="inherit" size={23} />
              ) : (
                <MUI.Typography variant="button">ENTRAR</MUI.Typography>
              )}
            </MUI.Button>
          </MUI.Stack>
        </MUI.Stack>
      </FormProvider>
    );
  } else if (step === "qr" && qrCode) {
    content = (
      <MUI.Stack
        width={["95%", "30rem", "30rem"]}
        alignItems="center"
        spacing={2}
      >
        <MUI.Typography variant="h6" textAlign="center">
          Configure o Autenticador
        </MUI.Typography>
        <MUI.Typography variant="body2" textAlign="center">
          Escaneie o QR code abaixo com o Google Authenticator ou similar:
        </MUI.Typography>
        <MUI.Box
          component="img"
          src={qrCode}
          alt="QR Code OTP"
          sx={{ maxWidth: 200, height: "auto" }}
        />
        {error && (
          <MUI.Typography color="error" variant="body2" textAlign="center">
            {error}
          </MUI.Typography>
        )}
        <MUI.Button
          variant="contained"
          onClick={() => setStep("otp")}
          fullWidth
        >
          Já escaneei, inserir código
        </MUI.Button>
        <MUI.Button variant="text" onClick={() => setStep("login")} fullWidth>
          Voltar ao login
        </MUI.Button>
      </MUI.Stack>
    );
  } else {
    content = (
      <MUI.Stack
        width={["95%", "30rem", "30rem"]}
        component="form"
        onSubmit={handleOtpSubmit}
        spacing={2}
      >
        <MUI.Typography variant="h6" textAlign="center">
          Código de Autenticação
        </MUI.Typography>
        <MUI.Typography variant="body2" textAlign="center">
          Digite o código de 6 dígitos do seu autenticador:
        </MUI.Typography>
        {error && (
          <MUI.Typography color="error" variant="body2" textAlign="center">
            {error}
          </MUI.Typography>
        )}
        <MUI.TextField
          inputRef={otpInputRef}
          label="Código OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          fullWidth
          size="small"
          inputProps={{ maxLength: 6, pattern: "[0-9]{6}" }}
          placeholder="000000"
        />
        <MUI.Button
          type="submit"
          variant="contained"
          fullWidth
          onClick={(e) => {
            const storedSecret = sessionStorage.getItem("@webSDS:tempSecret");
            if (!storedSecret) {
              setError("Configuração incompleta. Recomece o processo.");
              return;
            }
            handleOtpSubmit(e);
          }}
          disabled={loading || otp.length !== 6}
        >
          {loading ? (
            <MUI.CircularProgress color="inherit" size={23} />
          ) : (
            "Validar Código"
          )}
        </MUI.Button>
        <MUI.Button variant="text" onClick={() => setStep("login")} fullWidth>
          Voltar ao login
        </MUI.Button>
      </MUI.Stack>
    );
  }

  return (
    <MUI.Stack
      width="100%"
      alignItems="center"
      justifyContent="center"
      height={["60.2vh", "60.2vh", "60.2vh", "60.2vh", "73.4vh"]}
    >
      {content}
    </MUI.Stack>
  );
};
